let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aYfhn")).then(() => parcelRequire('ajohf'));